import React from 'react';
import classNames from 'classnames';
import { Constants } from '@praktio/common';

import './Document.scss';

const { TemplateTypes } = Constants;

const slideClass = (slideType) => {
  switch (slideType) {
    case TemplateTypes.Explanation:
      return 'exp-slide';
    default:
      return '';
  }
};

// TODO: Used in TextLoader.tsx, update this to TS
const Document = ({
  answeredClass,
  baseClass,
  className,
  children,
  docRef,
  isBestEdit,
  isExcerpt,
  onMouseUp,
  sharedWidth,
  shouldPulse,
  showExplain,
  singlePanel,
  slideType,
  symbolClass,
  style,
  textClass,
  triPanel,
  windowSize,
  disabled,
}) => {
  const triPanelClass = triPanel && !isBestEdit ? 'triPanel' : '';
  const singlePanelClass = singlePanel ? 'single-panel' : '';

  return (
    <div
      tabIndex={0}
      role="region"
      aria-label="Document - Scrollable content area."
      style={style}
      className={classNames(
        answeredClass,
        className,
        showExplain,
        symbolClass,
        'document',
        textClass,
        'text-content',
        triPanelClass,
        singlePanelClass,
        slideClass(slideType),
        baseClass,
        windowSize,
        {
          'shared-width': sharedWidth,
          'should-pulse': shouldPulse,
          isExcerpt,
          disabled,
        },
      )}
      onKeyDown={(event) => {
        if (
          (event.key !== 'Enter' && event.key !== ' ') ||
          slideType !== TemplateTypes.ClickBestSpot
        ) {
          return;
        }

        onMouseUp(event);
      }}
      onMouseUp={onMouseUp}
      ref={docRef}
    >
      {children}
    </div>
  );
};

export default Document;
